import {
  CodeBracketSquareIcon,
  DocumentTextIcon,
} from "@heroicons/react/24/solid";
import { useState } from "react";
import { useRecoilState } from "recoil";
import { showScriptsSubmoduleState } from "../atoms/atom";
import useGetScripts from "../hooks/useGetScripts";
import TableFilters from "../TableFilters";
import { ModuleScriptTable } from "./ModuleScriptTable";
import { SubModuleScriptTable } from "./SubModuleScriptTable";
export const ScriptsView = () => {
  const {
    data: scriptsData,
    refetch: refetchScript,
    status: refetchStatus,
  } = useGetScripts();
  const [isShow, setIsShow] = useRecoilState(showScriptsSubmoduleState);
  const [filterText, setFilterText] = useState("");
  //Getting distinct group name for table creation
  const uniqueGroupNames = [
    ...new Set(scriptsData?.map((item) => item.groupName)),
  ];

  return (
    <div className="animate-fade-in-down bg-white space-y-3 px-8 py-4">
      <div className="w-full">
        <div className="flex gap-2 items-center">
          <div>
            <CodeBracketSquareIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
          </div>
          <div className="flex flex-col leading tight">
            <h3 className="text-xs font-medium text-gray-500">
              Utilities Module
            </h3>
            <h1 className="mr-auto font-bold text-primary text-md uppercase">
              Script CONFIGURATION
            </h1>
          </div>
        </div>
        <div className="h-0.5 w-full border-b-2 border-secondary mt-2 mb-4" />
        {!isShow ? (
          <>
            <div className="mt-4 rounded-md pb-4">
              <div className="flex flex-row item-center space-x-4">
                <TableFilters
                  setIsSearching={false}
                  setFilterText={setFilterText}
                  moduleDetails="Module Name"
                  textInputName="moduleName"
                  disabledButton={false}
                />
              </div>
            </div>
            {uniqueGroupNames &&
              uniqueGroupNames.map((module, index) => {
                const moduleData = scriptsData?.filter(
                  (x) => x.groupName === module
                );
                return (
                  <div key={index}>
                    <ModuleScriptTable
                      moduleData={moduleData}
                      moduleName={module}
                      filteredText={filterText}
                      setFilterText={setFilterText}
                      index={uniqueGroupNames.length}
                    />
                  </div>
                );
              })}
          </>
        ) : (
          <>
            <SubModuleScriptTable refetchScript={refetchScript} />
          </>
        )}
      </div>
    </div>
  );
};
